import * as actionTypes from '../actions/actionTypes';

const initialState = { id: '', active: false, lang: 'en', uid: '' };

const userReducer = (state = initialState, action) => {

    switch (action.type) {
        case actionTypes.CREATE_USER: {
            return {
                ...state,
                ...action.data,
                active: true
            }
        }
        case actionTypes.FETCH_USER: {
            return {
                ...state,
                ...action.data,
                active: action.uid && action.name ? true : false
            }
        }
        case actionTypes.CLEAR_USER_DATA: {
            return initialState
        }
        default: {
            return state
        }
    }
}

export default userReducer;